import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { useLanguageAnimation } from './LanguageAnimationContext';

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();
    const { triggerAnimation } = useLanguageAnimation();

    const changeLanguage = (lng) => {
        if (i18n.language !== lng) {
            triggerAnimation(); // Trigger animation only if language changes
            i18n.changeLanguage(lng);
        }
    };

    const isActive = (lng) => i18n.language === lng;

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                ml: { xs: 1, md: 2 },
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: '24px',
                padding: '2px',
                background: 'rgba(0, 0, 0, 0.1)',
                backdropFilter: 'blur(4px)'
            }}
        >
            <LanguageIcon
                sx={{
                    fontSize: 16,
                    mx: 1,
                    color: 'common.white',
                    opacity: 0.7
                }}
            />
            <Button
                onClick={() => changeLanguage('en')}
                sx={{
                    minWidth: 'unset',
                    px: 1,
                    py: 0.5,
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    color: 'common.white',
                    borderRadius: '20px',
                    backgroundColor: isActive('en') ? 'rgba(108, 99, 255, 0.5)' : 'transparent',
                    '&:hover': {
                        backgroundColor: isActive('en')
                            ? 'rgba(108, 99, 255, 0.7)'
                            : 'rgba(255, 255, 255, 0.1)'
                    }
                }}
            >
                EN
            </Button>
            <Button
                onClick={() => changeLanguage('ua')}
                sx={{
                    minWidth: 'unset',
                    px: 1,
                    py: 0.5,
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    color: 'common.white',
                    borderRadius: '20px',
                    backgroundColor: isActive('ua') ? 'rgba(108, 99, 255, 0.5)' : 'transparent',
                    '&:hover': {
                        backgroundColor: isActive('ua')
                            ? 'rgba(108, 99, 255, 0.7)'
                            : 'rgba(255, 255, 255, 0.1)'
                    }
                }}
            >
                UA
            </Button>
        </Box>
    );
};

export default LanguageSwitcher;